import { useState, useEffect, useCallback } from "react";
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { fr } from 'date-fns/locale';
import 'styles/quoteduplicatepopup.css';
import api from "api";

registerLocale('fr', fr);

// vérifie si deux dates tombent le même jour
const isSameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

const QuoteDuplicatePopup = (
    {
        quoteId, // id du devis à dupliquer
        onClose, // ferme le popup
        setReloadQuotes, // recharge la liste des devis
    }
) => {

    const [ existingDates, setExistingDates ] = useState([]); // dates déjà utilisées par le devis
    const [ selectedDate, setSelectedDate ] = useState(null); // nouvelle date choisie
    const [ error, setError ] = useState(null);
    const [ saving, setSaving ] = useState(false);

    // récupère les dates existantes du devis à dupliquer
    useEffect(() => {
        api.get(`quote/${quoteId}/getdates`)
        .then(response => {
            setExistingDates(response.data.map(d => new Date(d.timestamp)));
        });
    }, [quoteId]);

    const handleChange = (date) => {
        setSelectedDate(date);
        setError(null);
    };

    // envoie la demande de duplication avec la nouvelle date
    const handleConfirm = () => {
        if (!selectedDate) {
            setError("Choisissez une date");
            return;
        }
        if (existingDates.some(d => isSameDay(d, selectedDate))) {
            setError("La nouvelle date doit être différente des dates existantes du devis");
            return;
        }
        setSaving(true);
        api.post(`quote/${quoteId}/duplicate`, { new_date : selectedDate.getTime() })
        .then(() => {
            setReloadQuotes(true);
            onClose();
        })
        .catch(() => {
            setSaving(false);
            setError("Erreur lors de la duplication du devis");
        });
    };

    const handleKey = useCallback((e) => {
        if (e.key === 'Escape') onClose();
    }, [onClose]);

    useEffect(() => {
        document.addEventListener('keydown', handleKey);
        return () => document.removeEventListener('keydown', handleKey);
    }, [handleKey]);

    return (
        <div className="QuoteDuplicateOverlay" onClick={onClose}>
            <div className="QuoteDuplicatePopup" onClick={(e) => e.stopPropagation()}>
                <div className="RentmanClose" onClick={onClose}>X</div>
                <h3>Dupliquer le devis</h3>
                <div>Choisissez une nouvelle date, différente des dates existantes du devis :</div>
                <DatePicker
                    selected={selectedDate}
                    onChange={handleChange}
                    excludeDates={existingDates}
                    openToDate={existingDates.length > 0 ? existingDates[0] : new Date()}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    locale="fr"
                    dateFormat="dd/MM/yyyy"
                    inline
                />
                { error && <div className="QuoteDuplicateError">{error}</div> }
                <button
                    className="QuoteDuplicateConfirm"
                    disabled={!selectedDate || saving}
                    onClick={handleConfirm}
                >
                    Dupliquer
                </button>
            </div>
        </div>
    );
};

export default QuoteDuplicatePopup;
